module.exports = __webpack_public_path__ + "static/media/icon_localization_ramp.8a3b059c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_localization_ramp.svg
// module id = 624
// module chunks = 0